import React, { useEffect, useState } from "react"
import { Button } from "reactstrap"
import { get } from "helpers/api_helper"
import { settingsTime } from "./maintenanceForm"
import { maintenanceError } from "./useMaintenanceOperation"

export default function MaintenanceHistory({ refresh }) {
  const [page, setPage] = useState(1), [retry, setRetry] = useState(0), [read, setRead] = useState({ loading: true })
  useEffect(() => {
    let current = true
    setRead({ loading: true })
    get(`/settings-maintenance/history?page=${page}`).then(response => {
      const data = response?.data
      if (!Array.isArray(data?.items) || !Number.isSafeInteger(data.totalResults)) throw new Error("Invalid history")
      if (current) setRead({ data })
    }).catch(() => { if (current) setRead({ error: true }) })
    return () => { current = false }
  }, [page, refresh, retry])
  return <section aria-label="Maintenance action logs">
    <div className="system-settings__heading"><h5>Action logs</h5><Button size="sm" disabled={read.loading} onClick={() => setRetry(value => value + 1)}>Refresh action logs</Button></div>
    {read.loading && <p role="status">Loading action logs…</p>}
    {read.error && <p role="alert">Action logs could not be loaded. <Button size="sm" onClick={() => setRetry(value => value + 1)}>Retry action logs</Button></p>}
    {read.data && <>
      {!read.data.items.length && <p className="text-muted">No maintenance changes have been recorded.</p>}
      {read.data.items.map(item => {
        const added = (item.after?.whitelistedIps || []).filter(ip => !item.before?.whitelistedIps?.includes(ip))
        const removed = (item.before?.whitelistedIps || []).filter(ip => !item.after?.whitelistedIps?.includes(ip))
        return <article key={item.operationId} className="system-settings__history">
          <div className="system-settings__actions"><strong>{item.actorName || "Administrator"}</strong><span className={item.status === "completed" ? "text-success" : item.status === "failed" ? "text-danger" : "text-muted"}>{({ completed: "Saved", pending: "Pending confirmation", failed: "Not saved" })[item.status] || "Unknown result"}</span></div>
          <p className="mb-1">{item.reason}</p>
          <div>{settingsTime(item.completedAt || item.requestedAt)}</div>
          {item.status === "completed" && item.before && item.after && <>
            <strong>{item.before.webUnderMaintenance ? "On" : "Off"} → {item.after.webUnderMaintenance ? "On" : "Off"}</strong>
            {added.length > 0 && <div>IP exceptions added: {added.join(", ")}</div>}
            {removed.length > 0 && <div>IP exceptions removed: {removed.join(", ")}</div>}
            {!added.length && !removed.length && <div>IP exceptions unchanged.</div>}
          </>}
          {item.status === "failed" && <p>{maintenanceError(item.message)}</p>}
          <details className="system-settings__technical"><summary>Technical details</summary><div>Request: {item.operationId}</div><div>Requested: {settingsTime(item.requestedAt)}</div>{item.after && <div>Saved revision: {item.after.revision}</div>}</details>
        </article>
      })}
      {(read.data.totalResults > 10 || page > 1) && <div className="system-settings__actions justify-content-end mt-3">
        <Button size="sm" disabled={page <= 1} onClick={() => setPage(value => value - 1)}>Previous logs</Button>
        <span>Page {page} of {Math.max(page, Math.ceil(read.data.totalResults / 10))}</span>
        <Button size="sm" disabled={page * 10 >= read.data.totalResults} onClick={() => setPage(value => value + 1)}>Next logs</Button>
      </div>}
    </>}
  </section>
}
